import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import EventCollection from '~/glm/models/gds/event-collection';
import NamesCell from '~/glm/components/guest-list/cells/names-cell';
import PartyOfCell from '~/glm/components/guest-list/cells/party-of-cell';
import ClickCell from '~/glm/components/guest-list/cells/click-cell';
import TextCell from '~/glm/components/guest-list/cells/text-cell.jsx';
import ContactInfoCellVariant from './cells/contact-info-cell-variant';
import RsvpsCell from '~/glm/components/guest-list/cells/rsvps-cell.jsx';
import AnalyticsStore from '~/glm/models/analytics-store';
import SelectionCellGroup from '~/glm/components/guest-list-table/cells/selection-cell-group';
import cellStyles from './guest-row.scss';
import styles from './row.scss';

@observer
class OverviewHouseholdRow extends Component {
  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    gdsEvents: PropTypes.instanceOf(EventCollection).isRequired,
    household: PropTypes.instanceOf(GdsHouseholdModel).isRequired,
    editHousehold: PropTypes.func.isRequired,
    trackInviteSend: PropTypes.func.isRequired,
    trackThankYou: PropTypes.func.isRequired,
    trackMeal: PropTypes.func.isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore),
    onCopyFormLinkClick: PropTypes.func,
  };

  state = {
    highlight: false,
  };

  householdMembers = () => {
    const { household } = this.props;

    return household.members.map(value => value);
  };

  get partyCount() {
    return this.householdMembers().length;
  }

  toggleMemberSelection = guest => {
    // const guest = this.findMember(guestId);
    const curSelection = guest.selected;
    guest.setSelected(!curSelection);
  };

  componentDidMount() {
    const { gdsUiState } = this.props;
    if (gdsUiState.highlightedEventColumn) {
      this.setState({ highlight: true });
      setTimeout(() => {
        this.setState({ highlight: false });
        gdsUiState.setHighlightedEventColumn(null);
      }, 3000);
    }
  }

  renderRsvpCells = () => {
    const { gdsEvents, gdsUiState, household, analyticsStore } = this.props;
    const { highlight } = this.state;
    return gdsEvents.nonReceptionEvents.map(gdsEvent => {
      const { id } = gdsEvent;
      const highlightAnimation = highlight && gdsEvent === gdsUiState.highlightedEventColumn;

      return (
        <RsvpsCell
          key={id}
          displayUninvitedGuests
          analyticsStore={analyticsStore}
          highlightAnimation={highlightAnimation}
          gdsUiState={gdsUiState}
          event={gdsEvent}
          invitations={household.guestInvitations(id)}
          guests={this.householdMembers()}
        />
      );
    });
  };

  renderSelectionCells = () => {
    const guests = this.householdMembers();

    return <SelectionCellGroup group={guests} onClick={this.toggleMemberSelection} />;
  };

  render() {
    const { household, editHousehold, onCopyFormLinkClick } = this.props;

    return (
      <tr key={`household-row-${household.id}`} className={styles.householdRow}>
        {this.renderSelectionCells()}
        <NamesCell onClick={() => editHousehold(household)} guests={this.householdMembers()} />
        <ClickCell
          onClick={() => editHousehold(household)}
          onKeyDown={e => (e.key === 'Enter' ? editHousehold(household) : null)}
        >
          <PartyOfCell value={this.partyCount} />
        </ClickCell>
        <td>
          <ContactInfoCellVariant
            household={household}
            guests={this.householdMembers()}
            onContactClick={() => editHousehold(household)}
            onCopyFormLinkClick={onCopyFormLinkClick}
          />
        </td>
        {this.renderRsvpCells()}
        {
          <ClickCell
            onClick={() => editHousehold(household)}
            onKeyDown={e => (e.key === 'Enter' ? editHousehold(household) : null)}
          >
            <TextCell type="notes" value={household.coupleNote} className={cellStyles.notes} />
          </ClickCell>
        }
      </tr>
    );
  }
}

export default OverviewHouseholdRow;
